<template>
  <div class="play-rule-page">
    <div class="module">
      <div class="content">
        <div class="play-rule-detail">
          <h1 class="main-title">
            本站销售河内彩票<span class="active-text">5分</span>规则
          </h1>
          <p>第一章总则</p>
          <p>
            第一条棉据财政郎《彩票发行与销售管理暂行规定》以及彩票发行管理中心有关规则》结合计算机网络技术和数享型彩票的特点，结合《数字型电脑福利彩票"5分'游沈规则》之相关条款,制定本游戏规
          </p>
          <p>
            第二条本站彩票实行自愿购买,量力而行;凡下注者即被视为同意并遵守规则,
          </p>
          <p>第二章游戏方法</p>
          <p>第三条"五位数"的每注彩票由00000-99999中的任意5位自然数排列而成.</p>
          <p class="active-text">假设下列为开奖结果:</p>
          <p>依照开奖结果，中奖范例如下:</p>
          <table cellpadding="0" cellspacing="0">
            <thead>
              <th>万</th>
              <th>仟</th>
              <th>佰</th>
              <th>拾</th>
              <th>个</th>
            </thead>
            <tbody>
              <tr>
                <td>1</td>
                <td>2</td>
                <td>3</td>
                <td>4</td>
                <td>5</td>
              </tr>
            </tbody>
          </table>
          <p>四字中奖:</p>
          <p class="active-text">
            1234X;&nbsp;&nbsp;&nbsp;&nbsp;123x5;&nbsp;&nbsp;&nbsp;&nbsp;1X345;&nbsp;&nbsp;&nbsp;&nbsp;X2345;&nbsp;&nbsp;&nbsp;&nbsp;12X45;
          </p>
          <p>三字中奖:</p>
          <p class="active-text">
            123XX;&nbsp;&nbsp;&nbsp;&nbsp;12x4x;&nbsp;&nbsp;&nbsp;&nbsp;12XX5;&nbsp;&nbsp;&nbsp;&nbsp;1X34X;&nbsp;&nbsp;&nbsp;&nbsp;1X3X5;&nbsp;&nbsp;&nbsp;&nbsp;1XX45;&nbsp;&nbsp;&nbsp;&nbsp;X234x;&nbsp;&nbsp;&nbsp;&nbsp;X23X5;&nbsp;&nbsp;&nbsp;&nbsp;XX345
            ;
          </p>
          <p>二字中奖:</p>
          <p class="active-text">
            XXX45;&nbsp;&nbsp;&nbsp;&nbsp;XX3X5;&nbsp;&nbsp;&nbsp;&nbsp;XX34X;&nbsp;&nbsp;&nbsp;&nbsp;X2XX5;&nbsp;&nbsp;&nbsp;&nbsp;X2X4X;&nbsp;&nbsp;&nbsp;&nbsp;X23XX;&nbsp;&nbsp;&nbsp;&nbsp;1XXX5;&nbsp;&nbsp;&nbsp;&nbsp;1XX4X;&nbsp;&nbsp;&nbsp;&nbsp;1X3XX;&nbsp;&nbsp;&nbsp;&nbsp;12XXX
            ;
          </p>
          <p>一字中奖:</p>
          <p class="active-text">
            1XXXX;&nbsp;&nbsp;&nbsp;&nbsp;X2XXX;&nbsp;&nbsp;&nbsp;&nbsp;XX3XX;&nbsp;&nbsp;&nbsp;&nbsp;XXX4X;&nbsp;&nbsp;&nbsp;&nbsp;XXXX5
            :
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DropDownMenu from "@/components/DropDownMenu";
export default {
  data() {
    return {
      userInfo: null,
      choiceOption: "hn5fc",
      gameList: [],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    async initData() {
      this.computedGameList();
    },
    computedGameList() {
      this.$store.state.gameInfo.forEach((element) => {
        this.gameList.push({
          label: element.gameName,
          value: element.code,
        });
      });
    },
  },
  components: {
    DropDownMenu,
  },
};
</script>

<style lang="scss" scoped>
.play-rule-page {
  .play-rule-detail {
    padding: 20px;
    .main-title {
      font-size: 18px;
      margin: 10px 0;
      text-align: center;
    }
    table {
      border: 1px solid var(--primary-table-border-color);
      th,
      td {
        line-height: 30px;
        padding: 0 20px;
        background: #f0f0f0;
        &:not(:last-child) {
          border-right: 1px solid var(--primary-table-border-color);
        }
      }
      th {
        border-bottom: 1px solid var(--primary-table-border-color);
      }
    }
    p {
      line-height: 30px;
    }
  }
}
</style>
